import type { Dict } from "../i18n";

export const en: Dict = {
  "common.close": "Close",
  "boot.errorTitle": "The game could not start",
  "boot.webglHint": "Your browser could not start the 3D graphics. Try an updated browser with graphics acceleration available.",
  "boot.errorHint": "Try opening the game again. If it still fails, send the details below to support.",
  "boot.retry": "Try again",
  "boot.details": "Error details",
  "game.title": "VOID HUNTER",
  "game.slogan": "Hunt. Absorb. Ascend.",

  "menu.play": "Play",
  "menu.resume": "Resume",
  "menu.settings": "Settings",
  "menu.language": "Language",
  "menu.back": "Back",
  "menu.restart": "Restart",
  "menu.ranking": "🏆 Ranking",
  "menu.site": "Official site",
  "pvp.interact": "⚔️ PvP Arena",

  "hud.level": "Level",
  "hud.health": "Health",
  "hud.experience": "Experience",
  "hud.dash": "DASH",
  "hud.essence": "Essence",

  "combat.critical": "CRITICAL",
  "combat.blocked": "BLOCKED",
  "area.complete": "AREA CLEARED — the gate is open",
  "rift.lockedChampions": "🔒 {n} × {quem} left — in {onde}",
  "area.locked": "Gate locked · {n} left",
  "area.goal.territories": "explore territories",
  "area.goal.champions": "defeat champions",
  "area.goal.kills": "slay monsters",
  "area.goal.chests": "open chests",
  "area.goal.boss": "defeat the boss",
  "area.goal.boss.voidAlpha": "defeat the Apex Fang",
  "area.goal.boss.aetherColossus": "defeat the Aether Colossus",
  "area.goal.boss.guardian": "defeat the area Guardian",
  "region.unlockedNext": "NEW REGION UNLOCKED — {name} (Lv {n}+) · travel through the Rift Portal or the Map",
  "depth.new": "DEPTH {n} — the world came back stronger",
  "depth.treePoints": "🌳 +{n} Void Tree points",
  "depth.label": "Depth {n}",
  "depth.intro.title": "Depth {n} — the world turned over again!",
  "depth.intro.territories": "🗺️ Every territory and area mission asks to be reconquered again (kills, champion, chest).",
  "depth.intro.chests": "📦 World chests reopen — you can loot everything again.",
  "depth.intro.harder": "🔒 Gates between territories now ask for a slightly higher level than last loop.",
  "depth.intro.tree": "🌳 You got +{n} points to spend on the Void Tree.",
  "combat.weak": "WEAK!",
  "combat.resisted": "resisted",
  "combat.weakTo": "Weak to",
  "combat.tough": "Resists",
  "player.levelUp": "LEVEL UP",

  "game.paused": "PAUSED",
  "game.youDied": "YOU DIED",
  "game.respawning": "Respawning in {s}s...",

  "settings.title": "Settings",
  "settings.language": "Language",
  "settings.controls": "Controls",
  "settings.resetProgress": "Reset Progress",
  "settings.resetConfirm": "Erase ALL progress (level, essence, upgrades)? This cannot be undone.",
  "settings.resetYes": "Erase",
  "settings.resetNo": "Cancel",

  "controls.move": "Move",
  "controls.attack": "Attack",
  "controls.hook": "Hook",
  "controls.dash": "Dash",
  "controls.pause": "Pause",
  "controls.interact": "Interact",
  "controls.stick": "Joystick",
  "controls.sprint": "Run / reposition",
  "controls.auto": "Automatic",
  "controls.devHint": "Dev: WASD · RMB hook · Space run · E · Esc (attack is automatic)",

  "hint.start": "Joystick to move · attack is automatic · HOOK & RUN buttons",

  "essence.power": "Power",
  "essence.vitality": "Vitality",
  "essence.agility": "Agility",
  "essence.fortitude": "Fortitude",
  "essence.ferocity": "Ferocity",
  "essence.title": "Essences",
  "essence.collected": "+{n} {name}",

  "enemy.voidling": "Shardling",
  "enemy.voidSpitter": "Void Spitter",
  "enemy.voidHusk": "Void Husk",
  "enemy.shardCrawler": "Shard Crawler",
  "enemy.veinLurker": "Vein Lurker",
  "enemy.stormLance": "Storm Lance",
  "enemy.ruinSentinel": "Ruin Sentinel",
  "enemy.voidWisp": "Void Wisp",
  "enemy.voidRunner": "Riftclaw",
  "enemy.voidBrute": "Stoneback",

  "hook.ready": "Hook ready",
  "hook.cooldown": "Hook recharging",

  "altar.name": "VOID ALTAR",
  "altar.title": "Void Altar",
  "altar.interact": "Interact",
  "altar.cost": "Cost",
  "altar.level": "Lv {n}",
  "altar.insufficient": "Not enough Essence",
  "altar.close": "Close",
  "altar.effect.power": "+{n} Damage",
  "altar.effect.vitality": "+{n} Max HP",
  "altar.effect.agility": "+{n}% Move Speed",
  "altar.effect.fortitude": "+{n} Armor",
  "altar.effect.ferocity": "+{n}% Crit Chance",

  "enemy.corruptedBrute": "Rift Warden",

  "boss.voidKing": "Void King",
  "boss.voidAlpha": "APEX FANG",
  "boss.riftSeer": "RIFT SEER",
  "boss.defeated": "APEX FANG DEFEATED",
  "boss.phaseRage": "VOID RAGE",
  "boss.interrupt": "INTERRUPT!",

  "region.forestEntrance": "Forest Entrance",
  "region.voidClearing": "Void Clearing",
  "region.corruptedGrove": "Corrupted Grove",
  "region.alphaDen": "Alpha Den",
  "region.pathOpened": "The path to the Alpha Den has opened.",

  "interaction.challengeBoss": "Challenge Apex Fang",
  "reward.alphaSoul": "Apex Soul acquired",
  "elite.progress": "Elite slain — {n}/{total}",
  "boss.awakens": "APEX FANG AWAKENS",
  "boss.fury": "🔥 FURY — the boss hits harder!",
  "boss.leashWarn": "⚠️ You left the arena — the boss gives up in {s} s",
  "boss.leashReset": "The boss lost sight of you and returned to its lair. Come back to challenge it again.",
  "event.bossAwakens": "EVENT BOSS — A RIFT TEARS OPEN!",
  "event.bossDefeated": "Event Boss defeated — exclusive weapon!",
  // 10.9AC — Void Invasion (4h event)
  "worldEvent.start": "⚠️ VOID INVASION! Kill the corrupted to gain power and unlock the boss!",
  "worldEvent.progress": "Corrupted until the boss: {left}",
  "worldEvent.bossReady": "THE BOSS IS UNLOCKED — face it!",
  "worldEvent.bossAwakens": "{name} awakens! (rebirth {tier})",
  "worldEvent.bossDown": "Boss down! It will return stronger — kill more corrupted.",
  "worldEvent.end": "The Void Invasion has ended. The temporary powers are gone.",
  "worldEvent.boss.wrath": "Wrath Alpha",
  "worldEvent.boss.frost": "Frost Alpha",
  "worldEvent.boss.plague": "Plague Alpha",
  "worldEvent.boss.storm": "Storm Alpha",
  "worldEvent.boss.abyss": "Abyss Alpha",

  // 10.9AJ — Boss Zone (Titan Rift)
  "bossZone.portal": "👑 Titan Rift",
  "bossZone.exitPortal": "🏠 Back to Sanctuary",
  "bossZone.enter": "Enter the Titan Rift",
  "bossZone.exit": "Back to Sanctuary",
  "bossZone.welcome": "👑 TITAN RIFT — each room holds a boss. Doors require level.",
  "bossZone.challenge": "👑 Challenge {name}",
  "bossZone.locked": "🔒 Room locked — needs Lv {n}",
  "bossZone.lockedTree": "🔒 {name} — needs the Void Tree {have}/{need} pts",
  "bossZone.cooldown": "⏳ {name} returns in {t}",
  "bossZone.awakens": "{name} awakens!",
  "bossZone.defeated": "{name} fell! +XP, essence and a chest. Returns in {t}.",
  "bossZone.weaponDrop": "⚔️ BOSS WEAPON! Ultra-rare drop — {item}",
  "bossZone.left": "You left the Titan Rift.",
  "bossZone.r1": "Crimson Fang",
  "bossZone.r2": "Frost Eye",
  "bossZone.r3": "Plague Alpha",
  "bossZone.r4": "Astral Seer",
  "bossZone.r5": "Golden Tusk",
  "bossZone.r6": "Abyss Eye",
  "bossZone.r7": "Carmine Alpha",
  "bossZone.r8": "Void Seer",
  "bossZone.r9": "Primordial Alpha",
  "bossZone.r10": "The Final Eye",
  "bossZone.r11": "Ascendant Guardian",
  "bossZone.r12": "Eternal Seer",
  "bossZone.r13": "Abyss Alpha",
  "bossZone.r14": "Infinite Seer",
  "bossZone.r15": "Omega Titan",
  "areaBoss.awakens": "THE AREA GUARDIAN EMERGES!",
  "guardian.label": "👑 Guardian · {n}/{need} kills",
  "bossZone.sealed": "🔒 The door sealed shut! You only leave by winning… or falling.",
  "bossZone.noFlee": "🔒 There's nowhere to run in the Rift — win or fall!",
  "world.flee": "🏳️ Flee the fight",
  "world.fleeSub": "gives up the boss and returns to the Sanctuary",
  "world.fled": "You fled the fight. The boss will wait for you.",
  "guardian.ready": "👑 GUARDIAN AWAKE — enter the arena",
  "guardian.awakened": "👑 The Guardian has awakened at the Arena — go face it!",
  "guardian.challenge": "👑 Face the Guardian",
  "guardian.progress": "👑 Guardian: {n}/{need} kills",
  "areaBoss.defeated": "Area Guardian defeated!",

  "settings.audio": "Audio",
  "audio.master": "Master",
  "audio.music": "Music",
  "audio.sfx": "SFX",

  "touch.hook": "HOOK",
  "touch.sprint": "RUN",
  "touch.spell": "SPELL",
  "spell.warrior": "Seismic Slam",
  "spell.warrior2": "Charge", "spell.warrior2.d": "Lunge forward dealing damage and knockback.",
  "spell.warrior3": "War Cry", "spell.warrior3.d": "6s: +30% damage, +40% resistance and heals 15% HP.",
  "spell.archer2": "Hunter's Focus", "spell.archer2.d": "6s: +25% damage, +30% attack speed and +15% crit.",
  "spell.archer3": "Evasive Leap", "spell.archer3.d": "Leap forward (brief invulnerability) hurting anyone crossed.",
  "spell.mage2": "Meteor", "spell.mage2.d": "Calls a meteor ahead — big area damage after a moment.",
  "spell.mage3": "Arcane Barrier", "spell.mage3.d": "6s: +50% resistance and heals 10% HP.",
  "spell.necromancer2": "Soul Burst", "spell.necromancer2.d": "Arcane blast around the Hunter.",
  "spell.necromancer3": "Void Plague", "spell.necromancer3.d": "Creates a zone dealing damage over 4s.",
  "spell.buffOn": "✨ {name} active!",
  "shop.potion": "Health Potions ×3",
  "potion.none": "No potions — buy in the Shop.",
  "potion.full": "Health already full.",
  "potion.used": "🧪 +{n} HP!",
  "potion.got": "🧪 +{n} potions!",
  "spell.archer": "Arrow Rain",
  "spell.mage": "Arcane Nova",
  "spell.necromancer": "Void Legion",
  "spell.summonCast": "🧟 +{n} servants summoned!",
  "touch.interact": "USE",

  // ---- Fase 4: equipamento / loot / maestria ----
  "inventory.title": "Bag & equipment",
  "nav.bag": "Bag",
  "nav.character": "Hero",
  "nav.tree": "Upgrade",
  "nav.world": "World",
  "inventory.storage": "Bag: {count}/{capacity} slots · automatic pickup",
  "inventory.slotEmpty": "Empty",
  "inventory.equipHint": "Tap a weapon in your bag to compare and equip it. Your previous weapon returns to the bag.",
  "inventory.bagHint": "No items in this filter. Collected weapons and armor appear here. Hunt monsters or open chests to find more.",
  "weaponSlot.mainHand": "MAIN",
  "weaponSlot.soon": "Weapon loadout — coming soon",
  "weaponSlot.soonShort": "Soon",
  "weaponSlot.unlockLevel": "Unlocks at Level {level}",
  "weaponSlot.vip": "VIP weapon slot: +1 weapon attacking in your chain for VIPs or VIP Pass holders",
  "weaponSlot.vipActive": "VIP active — extra weapon slot unlocked (+1 weapon in your chain)",
  "inventory.autoBest": "⚡ Equip strongest weapon",
  "inventory.autoBestDone": "Equipped strongest weapon: {name}",
  "inventory.autoBestAlready": "You already have the strongest weapon",
  "inventory.autoBestNone": "No weapon in your bag",
  "inventory.equipBest": "Equip best",
  "inventory.bestNone": "Nothing better in your bag to equip",
  "inventory.bestEquippedAll": "Best build: {n} weapons (hand + chain) · {armor}",
  "inventory.bestArmorSwapped": "{n} armor piece(s) swapped",
  "inventory.bestArmorKept": "armor was already the best",
  "weaponType.sword": "Sword",
  "weaponType.axe": "Axe",
  "weaponType.bow": "Bow",
  "weaponType.crossbow": "Crossbow",
  "weaponType.tome": "Tome",
  "weaponType.mace": "Mace",
  "weaponType.staff": "Staff",
  "inventory.filter.all": "All",
  "inventory.filter.weapon": "Weapon",
  "inventory.filter.armor": "Armor",
  "inventory.filter.accessory": "Accessory",
  "inventory.empty": "No items yet — hunt to find loot.",
  "inventory.full": "Inventory full",

  "equipment.equip": "Equip",
  "equipment.unequip": "Unequip",
  "equipment.equipped": "Equipped",
  "equipment.inChain": "In chain",
  "equipment.damage": "Damage",
  "equipment.dps": "DPS",
  "equipment.level": "Lv",
  "equipment.mastery": "Mastery",
  "equipment.upgrade": "Upgrade",
  "equipment.shards": "shards",
  "equipment.maxLevel": "Max level",
  "equipment.convert": "To shards",
  "equipment.slotLocked": "Slot locked",
  "slot.unlock.elite": "Unlocks by defeating 1 Elite — any territory's champion (crown)",
  "slot.unlock.gate": "Unlocks by opening the Alpha Den",
  "slot.unlock.boss": "Unlocks by defeating Apex Fang — Forgotten Forest, in the Alpha Den (south of the map)",
  "slot.unlock.colossus": "Unlocks by defeating Aether Colossus — Shattered Wilds, at the Colossus Gate",
  "equipment.head": "Head",
  "equipment.chest": "Chest",
  "equipment.accessory": "Accessory",
  "equipment.attr.damage": "Damage",
  "equipment.attr.attackSpeed": "Attack Speed",
  "equipment.attr.critChance": "Crit Chance",
  "equipment.attr.critDamage": "Crit Damage",
  "equipment.attr.maxHp": "Max HP",
  "equipment.attr.armor": "Armor",
  "equipment.attr.moveSpeed": "Move Speed",
  "equipment.attr.attackRange": "Attack Range",
  "equipment.attr.dmgSlash": "Slashing Damage",
  "equipment.attr.dmgPierce": "Piercing Damage",
  "equipment.attr.dmgBlunt": "Blunt Damage",
  "equipment.attr.dmgArcane": "Arcane Damage",
  "equipment.attr.defSlash": "Slashing Defense",
  "equipment.attr.defPierce": "Piercing Defense",
  "equipment.attr.defBlunt": "Blunt Defense",
  "equipment.attr.block": "Block Chance",
  "equipment.attr.regen": "Regeneration",

  "rarity.common": "Common",
  "rarity.uncommon": "Uncommon",
  "rarity.rare": "Rare",
  "rarity.epic": "Epic",
  "rarity.legendary": "Legendary",
  "rarity.mythic": "Mythic",

  "weapon.sword": "Void Blade",
  "weapon.axe": "Void Cleaver",
  "weapon.bow": "Void Bow",
  "weapon.staff": "Void Staff",
  "weapon.crossbow": "Void Crossbow",
  "weapon.tome": "Void Tome",
  "weapon.eclipseBlade": "Eclipse Blade",
  "weapon.eclipseCleaver": "Eclipse Cleaver",
  "weapon.eclipseMaul": "Eclipse Maul",
  "weapon.eclipseBow": "Eclipse Bow",
  "weapon.eclipseStaff": "Eclipse Staff",
  "weapon.eclipseCrossbow": "Eclipse Crossbow",
  "weapon.eclipseTome": "Eclipse Tome",
  "armor.eclipseCrown": "Eclipse Crown",
  "armor.eclipseAegis": "Eclipse Aegis",
  "armor.eclipseGrips": "Eclipse Grips",
  "armor.eclipseTreads": "Eclipse Treads",
  "armor.eclipseSeal": "Eclipse Seal",
  "weapon.umbralSword": "Umbral Blade",
  "weapon.umbralAxe": "Umbral Axe",
  "weapon.umbralMace": "Umbral Maul",
  "weapon.umbralBow": "Umbral Bow",
  "weapon.umbralStaff": "Umbral Staff",
  "weapon.umbralCrossbow": "Umbral Crossbow",
  "weapon.umbralTome": "Umbral Tome",
  "armor.umbralHead": "Helm Umbral",
  "armor.umbralChest": "Aegis Umbral",
  "armor.umbralGloves": "Grips Umbral",
  "armor.umbralBoots": "Treads Umbral",
  "armor.umbralAccessory": "Seal Umbral",
  "weapon.astralSword": "Astral Blade",
  "weapon.astralAxe": "Astral Axe",
  "weapon.astralMace": "Astral Maul",
  "weapon.astralBow": "Astral Bow",
  "weapon.astralStaff": "Astral Staff",
  "weapon.astralCrossbow": "Astral Crossbow",
  "weapon.astralTome": "Astral Tome",
  "armor.astralHead": "Helm Astral",
  "armor.astralChest": "Aegis Astral",
  "armor.astralGloves": "Grips Astral",
  "armor.astralBoots": "Treads Astral",
  "armor.astralAccessory": "Seal Astral",
  "weapon.sideralSword": "Sidereal Blade",
  "weapon.sideralAxe": "Sidereal Axe",
  "weapon.sideralMace": "Sidereal Maul",
  "weapon.sideralBow": "Sidereal Bow",
  "weapon.sideralStaff": "Sidereal Staff",
  "weapon.sideralCrossbow": "Sidereal Crossbow",
  "weapon.sideralTome": "Sidereal Tome",
  "armor.sideralHead": "Helm Sidereal",
  "armor.sideralChest": "Aegis Sidereal",
  "armor.sideralGloves": "Grips Sidereal",
  "armor.sideralBoots": "Treads Sidereal",
  "armor.sideralAccessory": "Seal Sidereal",
  "weapon.stellarSword": "Stellar Blade",
  "weapon.stellarAxe": "Stellar Axe",
  "weapon.stellarMace": "Stellar Maul",
  "weapon.stellarBow": "Stellar Bow",
  "weapon.stellarStaff": "Stellar Staff",
  "weapon.stellarCrossbow": "Stellar Crossbow",
  "weapon.stellarTome": "Stellar Tome",
  "armor.stellarHead": "Helm Stellar",
  "armor.stellarChest": "Aegis Stellar",
  "armor.stellarGloves": "Grips Stellar",
  "armor.stellarBoots": "Treads Stellar",
  "armor.stellarAccessory": "Seal Stellar",
  "weapon.nebularSword": "Nebular Blade",
  "weapon.nebularAxe": "Nebular Axe",
  "weapon.nebularMace": "Nebular Maul",
  "weapon.nebularBow": "Nebular Bow",
  "weapon.nebularStaff": "Nebular Staff",
  "weapon.nebularCrossbow": "Nebular Crossbow",
  "weapon.nebularTome": "Nebular Tome",
  "armor.nebularHead": "Helm Nebular",
  "armor.nebularChest": "Aegis Nebular",
  "armor.nebularGloves": "Grips Nebular",
  "armor.nebularBoots": "Treads Nebular",
  "armor.nebularAccessory": "Seal Nebular",
  "weapon.abyssalSword": "Abyssal Blade",
  "weapon.abyssalAxe": "Abyssal Axe",
  "weapon.abyssalMace": "Abyssal Maul",
  "weapon.abyssalBow": "Abyssal Bow",
  "weapon.abyssalStaff": "Abyssal Staff",
  "weapon.abyssalCrossbow": "Abyssal Crossbow",
  "weapon.abyssalTome": "Abyssal Tome",
  "armor.abyssalHead": "Helm Abyssal",
  "armor.abyssalChest": "Aegis Abyssal",
  "armor.abyssalGloves": "Grips Abyssal",
  "armor.abyssalBoots": "Treads Abyssal",
  "armor.abyssalAccessory": "Seal Abyssal",
  "weapon.omegaSword": "Omega Blade",
  "weapon.omegaAxe": "Omega Axe",
  "weapon.omegaMace": "Omega Maul",
  "weapon.omegaBow": "Omega Bow",
  "weapon.omegaStaff": "Omega Staff",
  "weapon.omegaCrossbow": "Omega Crossbow",
  "weapon.omegaTome": "Omega Tome",
  "armor.omegaHead": "Helm Omega",
  "armor.omegaChest": "Aegis Omega",
  "armor.omegaGloves": "Grips Omega",
  "armor.omegaBoots": "Treads Omega",
  "armor.omegaAccessory": "Seal Omega",
  "weapon.reaperEclipse": "Eclipse Reaper",
  "weapon.ruinEclipse": "Eclipse Ruin",
  "weapon.collapseEclipse": "Eclipse Collapse",
  "weapon.omenEclipse": "Eclipse Omen",
  "weapon.voidEclipse": "Eclipse Void",
  "weapon.boltEclipse": "Eclipse Shard",
  "weapon.runeEclipse": "Eclipse Rune",
  "armor.titanHeart": "Titan's Heart",
  "weapon.aetherScepter": "Aether Scepter",
  "weapon.arcCrossbow": "Arc Crossbow",
  "weapon.arcaneTome": "Aether Tome",
  // 10.9AO — armor T4/T5/T6
  // 10.9J7 — RENAMED (text only, id/nameKey untouched so a player's already-saved item doesn't
  // break): "Abyssal" duplicated the tier-13 set's name (nearly 20x stronger) — progression felt stagnant.
  "armor.abyssalHelm": "Glacial Helm",
  "armor.abyssalPlate": "Glacial Plate",
  "armor.abyssalGrips": "Glacial Grips",
  "armor.abyssalGreaves": "Glacial Greaves",
  "armor.abyssalSigil": "Glacial Sigil",
  "armor.titanCrown": "Titan Crown",
  "armor.titanBulwark": "Titan Bulwark",
  "armor.titanGauntlets": "Titan Gauntlets",
  "armor.titanTreads": "Titan Treads",
  "armor.titanSeal": "Titan Seal",
  "armor.primordialCrown": "Primordial Crown",
  "armor.primordialAegis": "Primordial Aegis",
  "armor.primordialFists": "Primordial Fists",
  "armor.primordialStriders": "Primordial Striders",
  "armor.primordialHeart": "Primordial Heart",
  "weapon.mace": "Void Mace",
  "weapon.stormMaul": "Storm Maul",
  "armor.head": "Void Helm",
  "armor.chest": "Void Plate",
  "armor.accessory": "Void Charm",
  "armor.shardHelm": "Shard Helm",
  "armor.tempestVisor": "Tempest Visor",
  "armor.wardenPlate": "Warden Plate",
  "armor.tempestMail": "Tempest Mail",
  "armor.shardGrips": "Shard Grips",
  "armor.galeWraps": "Gale Wraps",
  "armor.aetherGauntlets": "Aether Gauntlets",
  "armor.tempestGrips": "Tempest Grips", // 10.9J7 — T3, closes the level 35-49 gloves gap
  "armor.riftwalkBoots": "Riftwalk Boots",
  "armor.galestepBoots": "Galestep Boots",
  "armor.stonepathGreaves": "Stonepath Greaves",
  "armor.aetherRing": "Aether Ring",
  "armor.prismCharm": "Prism Charm",
  "armor.stormSigil": "Storm Sigil",
  "armor.tempestSigil": "Squall Sigil", // 10.9J7 — T3, closes the level 35-49 accessory gap (distinct name from T2's stormSigil on purpose)

  "chest.wooden": "Wooden Chest (up to rare)",
  "chest.void": "Void Chest (up to epic)",
  "chest.alpha": "Alpha Chest (up to legendary)",
  "chest.openTag": "Open chest", // 10.9EX
  "vip.soon": "Coming soon", // 10.9FB
  // 10.9FC — Grimorio
  "index.title": "Index",
  "index.count": "{got}/{total} discovered",
  "index.tier": "Tier {n}",
  "grim.title": "Grimoire",
  "grim.hint": "Tap a spell button (1, 2 or 3), then the spell to put in it.",
  "grim.buff": "BUFF",
  "grim.lvl": "Lv {n}",
  "spell.noTarget": "No target nearby",
  "spell.x.whirl": "Whirlwind",
  "spell.x.whirl.d": "Spin for 2.5 s hitting everything around (10 hits).",
  "spell.x.shockwave": "Shockwave",
  "spell.x.shockwave.d": "12 m line strike ahead that knocks monsters back.",
  "spell.x.battlecry": "Battle Roar",
  "spell.x.battlecry.d": "8 s: +50% damage, +40% attack speed and heal 25% HP.",
  "spell.x.pierce": "Piercing Arrow",
  "spell.x.pierce.d": "22 m shot that goes through everything in line.",
  "spell.x.trap": "Explosive Trap",
  "spell.x.trap.d": "Plant it; it blows up hard when a monster gets close.",
  "spell.x.eagle": "Eagle Eye",
  "spell.x.eagle.d": "8 s: +35% crit chance and +30% damage.",
  "spell.x.chain": "Chain Lightning",
  "spell.x.chain.d": "Bolt that jumps between up to 6 monsters.",
  "spell.x.blizzard": "Blizzard",
  "spell.x.blizzard.d": "Area ahead for 5 s: damage and 50% slow.",
  "spell.x.arcshield": "Arcane Shield",
  "spell.x.arcshield.d": "6 s: take 50% less damage and heal 10% HP.",
  "spell.x.bones": "Bone Burst",
  "spell.x.bones.d": "14 m line of bones.",
  "spell.x.drain": "Drain Life",
  "spell.x.drain.d": "5 s area that damages and heals you per monster hit.",
  "spell.x.bonearmor": "Bone Armor",
  "spell.x.bonearmor.d": "8 s: -40% damage taken, +25% damage and heal 15% HP.",
  // 10.9FE — auditoria UX
  "inv.full": "Bag full — sell items",
  "voidTree.startHint": "Tap the Core (top) to spend your points",
  "world.needGoals": "Area missions",
  "mbar.inv": "Bag",
  "mbar.shop": "Shop",
  "mbar.missions": "Missions",
  "mbar.mail": "Mail",
  "mbar.vip": "VIP",
  "gift.weapons": "🎁 Gift: {n} legendary weapons in your bag! (compensation)", // 10.9FL
  "mail.itemsLabel": "items",
  "mail.elixirsLabel": "Protection Elixir",
  "mail.weekly.title": "🎁 Weekly Chest",
  "mail.weekly.body": "{weeks} week(s) in a row logging in every day! Here's an extra chest — with a Protection Elixir for the forge.",
  "mail.gift.title": "Compensation gift",
  "mail.gift.body": "Sorry about the weapon bug! Please accept 3 legendary weapons for your class.",
  "bossguide.title": "Boss Guide",
  "bossguide.hint": "Defeat bosses to get boss WEAPONS and ARMOR. At Lv 150 they drop Eclipse gear.",
  "bossguide.alpha": "Apex Fang",
  "bossguide.alpha.where": "Forgotten Forest — after clearing the area goals.",
  "bossguide.colossus": "Aether Colossus",
  "bossguide.colossus.where": "Shattered Wilds (Lv 10+) — at the Colossus gate.",
  "bossguide.guardian": "Region Guardian",
  "bossguide.guardian.where": "One per region — wakes when you clear the area; enter the arena to challenge.",
  "bossguide.rift": "Titans' Rift",
  "bossguide.rift.where": "Portal southeast of the Sanctuary — rooms by level, each with a boss.",
  "bossguide.titan": "Eclipse Titan (global boss)",
  "bossguide.titan.where": "Timed event — drops Eclipse gear (Lv 150).",
  "chest.opened": "Chest opened",
  "chest.bossWeapon": "⚔️ Boss Weapon in the chest!",
  "loot.obtained": "{rarity} {name} obtained",
  "loot.toShards": "duplicate {name} → +{n} shards",
  "evolve.copy": "+1 copy of {name} → evolution {bar}/{need} · +{n} shards",
  "evolve.bar": "⚗️ Evolution: {bar}/{need} identical copies → {rarity}",
  "evolve.needLevel": "Bar full! Evolves into {rarity} on its own at Lv {lvl}",
  "evolve.how": "Every copy of this weapon (same rarity) that drops goes in here and still gives forge shards. When full, it goes up a rarity and keeps its forge level.",
  "evolve.maxRarity": "⚗️ Top rarity — identical copies turn into forge shards",
  "evolve.done": "⚗️ {name} evolved! It is now {rarity}",
  "evolve.migrated": "⚗️ {n} repeated weapon(s) from your bag went into the evolution bar",
  "mail.refund.title": "Refund: Auto-Fusion",
  "mail.refund.body": "The 5-weapon fusion became automatic EVOLUTION (100 identical copies → next rarity), free for everyone. The diamonds you paid are back.",
  "loot.offClassSold": "{name} isn't for your class → sold +{n} 🪙",
  "loot.offClassSwept": "{n} other-class weapon(s) in your bag were sold: +{coins} 🪙",
  "loot.weaponCopy": "duplicate {name} → +1 copy",
  "shop.cat.consumable": "Consumables",
  "shop.cat.boost": "Boosts",
  "shop.cat.permanent": "Permanent",
  "shop.cat.rings": "Protection Rings",
  "shop.cat.pet": "Companion",
  "shop.cat.resource": "Resources",
  "shop.cat.protect": "Protection",
  "shop.cat.chest": "Chests",
  "shop.cat.cosmetic": "Cosmetic",
  "shop.title": "Shop",
  "shop.subtitle": "Spend the coins you earn by playing",
  "shop.bought": "{name} purchased!",
  "shop.noCoins": "Not enough Fragments",
  "hazard.frost": "extreme cold",
  "hazard.ember": "extreme heat",
  "hazard.gale": "gale",
  "hazard.storm": "electric storm",
  "hazard.warn": "⚠ {what} — you start losing health in {n}s",
  "hazard.hurt": "☠ {what} — you are losing health!",
  "hazard.equipIt": "👉 Tap to equip the {ring} (it's in your Bag)",
  "hazard.buyIt": "👉 Protection: {ring} · Shop 🪙 {n} — tap to open",
  "hazard.needSlot": "Protection: {ring} (Shop) — the accessory slot opens when you {how}",
  "armor.ringEmber": "Ember Ring",
  "armor.ringFrost": "Frost Ring",
  "armor.ringGale": "Gale Ring",
  "armor.ringStorm": "Storm Ring",
  "shop.item.ringEmber.name": "Ember Ring",
  "shop.item.ringEmber.desc": "Protects from extreme cold · equips from Lv 16",
  "shop.item.ringFrost.name": "Frost Ring",
  "shop.item.ringFrost.desc": "Protects from extreme heat · equips from Lv 16",
  "shop.item.ringGale.name": "Gale Ring",
  "shop.item.ringGale.desc": "Protects from gale winds · equips from Lv 16",
  "shop.item.ringStorm.name": "Storm Ring",
  "shop.item.ringStorm.desc": "Protects from electric storms · equips from Lv 16",
  "shop.ringBought": "{name} went to your bag — equip it in the accessory slot",
  "shop.needWeapon": "Equip a weapon first",
  "shop.item.potion.name": "Health Potions",
  "shop.item.potion.desc": "Instant heal on use — pack of {n}",
  "shop.item.heal.name": "Full Heal",
  "shop.item.heal.desc": "Restore all health now",
  "shop.item.hp.name": "Vitality Boost",
  "shop.item.hp.desc": "+{n} max health (permanent)",
  "shop.item.power.name": "Power Boost",
  "shop.item.power.desc": "+{n} damage (permanent)",
  "shop.item.shards.name": "Evolution Shards",
  "shop.item.shards.desc": "+{n} shards for equipped weapon",
  "shop.bought.count": "bought {n}×",
  "shop.item.forge.name": "Weapon Shards",
  "shop.item.forge.desc": "+{n} shards ✨ for the equipped weapon (forge material)",
  "shop.item.voidPoint.name": "Void Point",
  "shop.item.voidPoint.desc": "+{n} point to spend on the Void Tree",
  "shop.item.contract.name": "Hunt Contract",
  "shop.item.contract.desc": "+75% Fragments for 5 minutes",
  "shop.item.hunt.name": "Elite Call",
  "shop.item.hunt.desc": "Summons an Elite near you (high loot)",
  "shop.huntFail": "Leave the base (and no boss around) to call an Elite",
  "shop.contractOn": "Hunt Contract active!",
  "shop.item.pet.name": "Companion",
  "shop.item.pet.desc": "Orb that flies after essence, levels up from kills and boosts your damage",
  "pet.levelUp": "🐾 Companion Lv {n}!",
  "pet.shopLevel": "Lv {n}",
  "shop.owned": "Owned",
  "shop.alreadyOwned": "You already have the companion",
  "wardrobe.title": "Wardrobe",
  "wardrobe.live": "Live preview · drag to rotate",
  "wardrobe.equip": "Equip",
  "wardrobe.equipped": "Equipped",
  "wardrobe.wearing": "Wearing {name}",
  "outfit.void.name": "Void",
  "outfit.void.desc": "Default Hunter outfit",
  "outfit.aether.name": "Aether",
  "outfit.aether.desc": "Radiant gold",
  "outfit.tempest.name": "Tempest",
  "outfit.tempest.desc": "Storm teal",
  "outfit.ember.name": "Ember",
  "outfit.ember.desc": "Glowing orange",
  "outfit.astral.name": "Astral",
  "outfit.astral.desc": "Astral pink",
  "outfit.gold.name": "VIP Gold",
  "outfit.gold.desc": "Royal gold (💎 shop)",
  "outfit.obsidian.name": "Obsidian",
  "outfit.obsidian.desc": "Polished black with a cyan glow (💎 shop)",
  "outfit.royal.name": "Royalty",
  "outfit.royal.desc": "Deep crimson with gold trim (💎 shop)",
  "outfit.aurora.name": "Aurora",
  "outfit.aurora.desc": "Night blue, violet and green crystal — VIP Pass exclusive",
  "outfit.eclipse.name": "Eclipse",
  "outfit.eclipse.desc": "Black with amber embers — the Titan's lineage",
  "outfit.sideral.name": "Sideral",
  "outfit.sideral.desc": "Ice-steel and starlight",
  "outfit.abyssal.name": "Abyssal",
  "outfit.abyssal.desc": "Crimson from the depths",
  "outfit.omega.name": "Omega",
  "outfit.omega.desc": "White and gold — the top of the ladder",
  "wardrobe.buy": "Buy",
  "wardrobe.exclusive": "🔒 Exclusive to the VIP Shop (💎)",
  "wardrobe.exclusivePass": "🔒 VIP Pass exclusive",

  "mastery.level": "Mastery Lv",
  "mastery.nextReward": "Next",
  "mastery.max": "Mastery maxed",
  "mastery.endless": "No cap: +{p}% damage every level from here on",
  "mastery.levelUp": "Mastery Lv {n}!",
  "mastery.trait.voidEdge": "Void Edge",
  "mastery.trait.cleave": "Cleave",
  "mastery.trait.executioner": "Executioner",
  "mastery.trait.voidShot": "Void Shot",

  "slot.unlocked.head": "Head slot unlocked!",
  "slot.unlocked.chest": "Chest slot unlocked!",
  "slot.unlocked.accessory": "Accessory slot unlocked!",
  "slot.unlocked.gloves": "Gloves slot unlocked!",
  "slot.unlocked.boots": "Boots slot unlocked!",
  "weaponLevel.level": "LEVEL",
  "weaponLevel.damage": "DAMAGE",
  "weaponLevel.title": "Weapon Level",
  "weaponLevel.copies": "Copies",
  "weaponLevel.next": "Next",
  "weaponLevel.maxed": "MAX LEVEL",
  "wm.crit": "+Crit Chance",
  "wm.speed": "+Attack Speed",
  "wm.damage": "+Damage",
  "wm.crit2": "+Crit Chance",
  "wm.master": "+Damage (Master)",
  "slot.weapon": "Weapon",
  "slot.head": "Head",
  "slot.chest": "Chest",
  "slot.gloves": "Gloves",
  "slot.boots": "Boots",
  "slot.accessory": "Accessory",
  "inv.all": "All",

  // ---- Fase 5: minimapa / responsivo / acessibilidade ----
  "map.discovered": "Area discovered",
  "map.sanctuary": "Void Sanctuary",
  "map.altar": "Void Altar",
  "map.alphaDen": "Alpha Den",
  "settings.accessibility": "Accessibility",
  "settings.uiScale": "UI Scale",
  "settings.uiScaleSmall": "Small",
  "settings.uiScaleDefault": "Default",
  "settings.uiScaleLarge": "Large",
  "settings.reducedMotion": "Reduced Motion",
  "settings.graphics": "Graphics",
  "perf.autoLower": "⚙️ Graphics lowered to {n} (performance)",
  "gate.title": "Save your progress",
  "gate.sub": "Creating an account takes 10 seconds and makes sure you don't lose your Hunter if you change phones.",
  "gate.google": "Sign in with Google",
  "gate.void": "I have a Void ID (email)",
  "gate.email": "Email",
  "gate.pass": "Password (6+ characters)",
  "gate.create": "Create account",
  "gate.enter": "Sign in",
  "gate.guest": "Play as guest",
  "gate.note": "You can create the account later from the Ranking screen, without losing any progress.",
  "graphics.low": "Low",
  "graphics.medium": "Medium",
  "graphics.high": "High",
  "common.on": "On",
  "common.off": "Off",
  "orientation.rotateDevice": "Rotate your device to portrait",

  // ---- Fase 6: Character / Void Tree ----
  "character.title": "Hunter",
  "character.combatPower": "Combat Power",
  "character.level": "Level",
  "character.progression": "Progression",
  "levelUp.voidPoint": "Void Point",

  "voidTree.title": "Void Tree",
  "voidTree.points": "Points",
  "voidTree.reset": "Reset",
  "voidTree.resetConfirm": "Reset the Void Tree? All spent points return.",
  "voidTree.resetConfirmFree": "Reset the Void Tree? All points return. The 1st reset is FREE.",
  "voidTree.resetConfirmCost": "Reset the Void Tree? All points return. Costs 💎 {cost}.",
  "voidTree.resetDone": "Tree reset!",
  "voidTree.resetPaid": "Tree reset! (−{cost} 💎)",
  "voidTree.unlock": "Unlock",
  "voidTree.upgrade": "Upgrade",
  "voidTree.rank": "Rank",
  "voidTree.requires": "Requires",
  "voidTree.next": "Next",
  "voidTree.atMax": "Maxed (rank {n})", // 10.9EH
  "voidTree.max": "ALL", // 10.9EG — compra em lote
  "voidTree.maxed": "Maxed",

  "branch.power": "Power",
  "branch.survival": "Survival",
  "branch.agility": "Agility",
  "branch.class": "Class",
  "treeeffect.summonHpPct": "Servant health (HP)",
  "treeeffect.spellHealOnCast": "Heal on cast",
  "treeeffect.spellCritBonus": "Spell crit chance",
  "node.cls_war_rage": "War Blood", "node.cls_war_guard": "Bulwark", "node.cls_war_guard.d": "Casting Seismic Slam heals you 5% of max HP per rank.",
  "node.cls_arc_pierce": "Piercing", "node.cls_arc_rain": "Deluge",
  "node.cls_mag_surge": "Overload", "node.cls_mag_font": "Arcane Font", "node.cls_mag_font.d": "Casting Nova heals you 5% of max HP per rank.",
  "node.cls_nec_hp": "Void Flesh", "node.cls_nec_hp.d": "Servants now HAVE HP and act as decoys (enemies hit them). +30% HP per rank.",
  "node.cls_nec_reap": "Void Harvest",
  "treeeffect.spellDamagePct": "Spell Damage",
  "treeeffect.spellRadiusPct": "Spell Radius",
  "treeeffect.spellCdReducPct": "Spell Cooldown (lower)",
  "treeeffect.summonCount": "Servants per summon",
  "treeeffect.summonLifePct": "Servant lifetime",
  "treeeffect.summonSpeedPct": "Servant attack speed",
  "node.cls_war_dmg": "Heavy Blow", "node.cls_war_radius": "Shockwave", "node.cls_war_cd": "War Breath", "node.cls_war_quake": "Earthquake",
  "node.cls_arc_dmg": "Sharpened Tips", "node.cls_arc_radius": "Wide Rain", "node.cls_arc_cd": "Quick Quiver", "node.cls_arc_storm": "Arrow Storm",
  "node.cls_mag_dmg": "Arcane Focus", "node.cls_mag_radius": "Expanded Nova", "node.cls_mag_cd": "Swift Mind", "node.cls_mag_cataclysm": "Cataclysm",
  "node.cls_nec_dmg": "Void Claws", "node.cls_nec_life": "Servant Life", "node.cls_nec_life.d": "Servants are spectres: they have no HP — TIME is what counts. +25% duration per rank.",
  "node.cls_nec_cd": "Quick Call", "node.cls_nec_speed": "Servant Fury", "node.cls_nec_count": "More Servants", "node.cls_nec_count.d": "+1 servant per summon (and +2 to the alive cap) per rank.",
  "node.cls_nec_legion": "Void Legion",

  "stat.damage": "Damage",
  "stat.maxHp": "Max HP",
  "stat.armor": "Armor",
  "stat.moveSpeed": "Move Speed",
  "stat.attackSpeed": "Attack Speed",
  "stat.criticalChance": "Crit Chance",
  "stat.criticalDamage": "Crit Damage",
  "stat.attackRange": "Attack Range",
  "stat.hookRange": "Hook Range",
  "stat.hookCooldown": "Hook Cooldown",
  "stat.sprintDuration": "Sprint Duration",
  "stat.sprintCooldown": "Sprint Cooldown",
  "stat.dps": "Damage per Second",
  "stat.regen": "Regeneration",
  "stat.dmgSlash": "Slashing Damage",
  "stat.dmgPierce": "Piercing Damage",
  "stat.dmgBlunt": "Blunt Damage",
  "stat.defSlash": "Slashing Defense",
  "stat.defPierce": "Piercing Defense",
  "stat.defBlunt": "Blunt Defense",
  "stat.block": "Block Chance",
  "stat.resilience": "Resilience",
  "stat.vsElite": "Damage vs Elite/Boss",
  "stat.execute": "Execute Damage",
  "stat.chainCount": "Chained weapons",
  "stat.chainDps": "Chain DPS",
  "stat.chainReach": "Chain Reach",

  "attr.title": "ATTRIBUTES",
  "attr.dps": "DPS",
  "attr.hp": "HP",
  "attr.regen": "REGEN/s",
  "attr.dmgTaken": "damage taken",
  "attr.group.general": "General",
  "attr.group.damage": "Damage",
  "attr.group.defense": "Defense",
  "attr.group.mobility": "Mobility",
  "attr.group.chain": "Weapon chain",
  "attr.foot": "Slashing = sword/axe · Piercing = bow · Blunt = mace. Upgrade everything in the Void Tree (✦).",

  "source.base": "Base",
  "source.level": "Level",
  "source.altar": "Void Altar",
  "source.equipment": "Equipment",
  "source.voidTree": "Void Tree",

  "treeeffect.damagePct": "Damage",
  "treeeffect.critChance": "Crit Chance",
  "treeeffect.critDamagePct": "Crit Damage",
  "treeeffect.attackSpeedPct": "Attack Speed",
  "treeeffect.maxHpPct": "Max HP",
  "treeeffect.armorFlat": "Armor",
  "treeeffect.moveSpeedPct": "Move Speed",
  "treeeffect.hookRangePct": "Hook Range",
  "treeeffect.hookCdReducPct": "Hook Cooldown Reduction",
  "treeeffect.sprintDurationPct": "Sprint Duration",
  "treeeffect.sprintCdReducPct": "Sprint Cooldown Reduction",
  "treeeffect.vsElitePct": "vs Elite Damage",
  "treeeffect.executePct": "Execute Damage",
  "treeeffect.resiliencePct": "Resilience",
  "treeeffect.dmgSlashPct": "Slashing Damage",
  "treeeffect.dmgArcanePct": "Arcane Damage",
  "node.pow_arcane": "Arcane Power",
  "node.pow_rawdmg": "Raw Damage",
  "treeeffect.dmgPiercePct": "Piercing Damage",
  "treeeffect.dmgBluntPct": "Blunt Damage",
  "treeeffect.defSlashPct": "Slashing Defense",
  "treeeffect.defPiercePct": "Piercing Defense",
  "treeeffect.defBluntPct": "Blunt Defense",
  "treeeffect.blockChance": "Block Chance",
  "treeeffect.regenPct": "Regeneration",
  "treeeffect.attackRangeFlat": "Attack Range",

  "node.pow_slash": "Keen Edge",
  "node.pow_pierce": "Piercing Point",
  "node.pow_blunt": "Brutal Impact",
  "node.sur_regen": "Void Pulse",
  "node.sur_regen.d": "Regenerates HP continuously, even in combat (0.5% max HP/s per rank).",
  "node.sur_defslash": "Steel Skin",
  "node.sur_defpierce": "Void Plates",
  "node.sur_defblunt": "Stone Body",
  "node.sur_block": "Hunter's Guard",
  "node.sur_block.d": "Chance to BLOCK hits: half damage and less knockback (+4% per rank).",

  "node.pow_core": "Power Core",
  "node.pow_heavy": "Heavy Strike",
  "node.agi_reach": "Reach",
  "node.agi_reach.d": "Increases your weapon reach (+0.25 m per rank).",
  "node.pow_dmg1": "Power",
  "node.pow_atkspd": "Attack Tempo",
  "node.pow_crit": "Sharp Instinct",
  "node.pow_dmg2": "Overpower",
  "node.pow_ferocity": "Ferocity",
  "node.pow_hunter": "Hunter's Focus",
  "node.pow_hunter.d": "More damage against Elites & the Boss (per rank).",
  "node.pow_exec": "Void Execution",
  "node.pow_exec.d": "More damage against enemies below 30% HP (per rank).",
  "node.pow_dominance": "Void Dominance",
  "node.pow_dominance.d": "After 5 kills within 10s, gain +10% Damage for 5s.",
  "node.sur_hp1": "Vitality",
  "node.sur_armor": "Fortitude",
  "node.sur_hp2": "Endurance",
  "node.sur_resil": "Void Resilience",
  "node.sur_resil.d": "Reduces damage taken (per rank).",
  "node.sur_secondwind": "Second Wind",
  "node.sur_secondwind.d": "Below 25% HP, restore 25% HP (cooldown 30s).",
  "node.sur_unbreakable": "Unbreakable",
  "node.sur_unbreakable.d": "Survive a fatal blow with 1 HP (cooldown 120s).",
  "node.agi_move": "Swift",
  "node.agi_atkspd": "Hunter Reflexes",
  "node.agi_sprintdur": "Sprint Control",
  "node.agi_sprintcd": "Sprint Recovery",
  "node.agi_hookrange": "Hook Reach",
  "node.agi_hookcd": "Hook Recovery",
  "node.agi_predator": "Predator",
  "node.agi_predator.d": "After a kill, +20% Move Speed for 2s.",
  "node.agi_voidstep": "Void Step",
  "node.agi_voidstep.d": "When Sprint starts, -30% damage taken for 0.6s.",
  "node.pow_rage": "Rage",
  "node.pow_precision": "Absolute Precision",
  "node.pow_savagery": "Savagery",
  "node.pow_bloodedge": "Bloodedge",
  "node.pow_apex": "Hunter Apex",
  "node.pow_apex.d": "Capstone: +50% damage and +15% attack speed.",
  "node.sur_fortitude": "Fortitude",
  "node.sur_ironskin": "Iron Skin",
  "node.sur_veteran": "Veteran",
  "node.sur_regenmaster": "Regen Master",
  "node.sur_bastion": "Bastion",
  "node.sur_bastion.d": "Capstone: +50% max HP and +15% resilience.",
  "node.agi_swiftness": "Swiftness",
  "node.agi_flurry": "Flurry",
  "node.agi_dodge": "Dodge",
  "node.agi_relentless": "Relentless",
  "node.agi_wraith": "Wraith",
  "node.agi_wraith.d": "Capstone: +30% move speed and +15% block chance.",
  // 10.9EF — CLASS MASTERY (capstone + endless nodes)
  "node.cls_war_apex": "Warrior's Apex", "node.cls_war_apex.d": "Closes the Warrior path: +20% damage, +20 armor and +25% Seismic Slam. Opens endless Mastery.",
  "node.cls_war_inf_might": "Endless Might", "node.cls_war_inf_bulwark": "Endless Bulwark", "node.cls_war_inf_quake": "Endless Quake",
  "node.cls_arc_apex": "Archer's Apex", "node.cls_arc_apex.d": "Closes the Archer path: +20% piercing damage, +1.5 m range and +25% Arrow Rain. Opens endless Mastery.",
  "node.cls_arc_inf_aim": "Endless Aim", "node.cls_arc_inf_swift": "Endless Swiftness", "node.cls_arc_inf_volley": "Endless Volley",
  "node.cls_mag_apex": "Mage's Apex", "node.cls_mag_apex.d": "Closes the Mage path: +40% spell damage and +15% radius. Opens endless Mastery.",
  "node.cls_mag_inf_arcane": "Endless Arcane", "node.cls_mag_inf_flow": "Endless Flow", "node.cls_mag_inf_focus": "Endless Focus",
  "node.cls_nec_apex": "Necromancer's Apex", "node.cls_nec_apex.d": "Closes the Necromancer path: +1 minion, +50% minion HP and +25% damage. Opens endless Mastery.",
  "node.cls_nec_inf_horde": "Endless Horde", "node.cls_nec_inf_frenzy": "Endless Frenzy", "node.cls_nec_inf_blight": "Endless Blight",
  "node.pow_inf_dmg": "Endless Damage",
  "node.pow_inf_crit": "Endless Crit",
  "node.pow_inf_atkspd": "Endless Fury",
  "node.sur_inf_hp": "Endless Vitality",
  "node.sur_inf_armor": "Endless Armor",
  "node.sur_inf_regen": "Endless Healing",
  "node.agi_inf_speed": "Endless Stride",
  "node.agi_inf_atkspd": "Endless Flurry",
  "node.agi_inf_range": "Endless Reach",

  // ---- Fase 7: Void Sanctuary 2.0 (safe zone) ----
  "sanctuary.safeZone": "SAFE ZONE",
  "sanctuary.combatDisabled": "Combat disabled in the Sanctuary",
  "sanctuary.leaving": "LEAVING SANCTUARY",
  "sanctuary.combatZone": "COMBAT ZONE",
  "sanctuary.healing": "Regenerating",
  "combat.invalidFromSafeZone": "Can't attack from the Safe Zone",

  // ---- Fase 8: World / Regions / Creatures ----
  "region2.forgottenForest": "Forgotten Forest",
  "region2.shatteredWilds": "Shattered Wilds",
  "region.crystalFlats": "Crystal Flats",
  "region.brokenPass": "Broken Pass",
  "region.aetherCliffs": "Aether Cliffs",
  "region.wardenGrounds": "Warden Grounds",

  "enemy.shardfang": "Shardfang",
  "enemy.craghorn": "Craghorn",
  "enemy.aetherwing": "Aetherwing",
  "enemy.glintback": "Glintback",
  "enemy.shardWarden": "Shard Warden",

  "weapon.shardSaber": "Shard Saber",

  "chest.ruined": "Ruined Chest",
  "chest.shard": "Shard Chest",

  "rift.toWilds": "Enter the Shattered Wilds",
  "rift.toForest": "Back to the Forgotten Forest",
  "rift.inactive": "Rift inactive — defeat Apex Fang",
  "rift.gate": "🌀 Rift Gate",
  "rift.sub": "→ {name} · Lv {n}+",
  "bossZone.portalSub": "Bosses by level · rare loot",
  "pvp.portalSub": "1v1 · 3v3 · live",
  "region.entering": "ENTERING {name}",
  "map.rift": "Rift Gate",
  "map.wilds": "Shattered Wilds",
  "enemy.grounded": "GROUNDED",

  // ---- Fase 9: Aether Colossus ----
  "boss.aetherColossus": "AETHER COLOSSUS",
  "boss.awakensColossus": "THE AETHER COLOSSUS AWAKENS",
  "boss.crystalArmor": "Crystal Armor",
  "boss.coreExposed": "AETHER CORE EXPOSED",
  "boss.crystalBreak": "PLATE SHATTERED",
  "boss.hookPlate": "HOOK!",
  "boss.aetherCore": "Aether Core",
  "reward.aetherCore": "Aether Core acquired",
  "region.shatteredWildsCleared": "SHATTERED WILDS CLEARED",
  "colossus.gate": "Colossus Gate",
  "colossus.enter": "Face the Aether Colossus",
  "colossus.locked": "Sealed — defeat the Wardens and explore the Shattered Wilds",
  "colossus.arena": "Ancient Fracture",
  "path.unknown": "PATH UNKNOWN",

  // ---- Fase 10: Tempest Reach (Região 3) ----
  "region.tempestReach": "Tempest Reach",
  "region.windwardPath": "Windward Path",
  "region.skyruinTerrace": "Skyruin Terrace",
  "region.thunderstoneRidge": "Thunderstone Ridge",
  "region.tempestCrown": "Tempest Crown",
  "region.tempestReachUnlocked": "NEW REGION UNLOCKED — TEMPEST REACH",
  "region.stormBeyond": "A STORM STIRS BEYOND",
  "enemy.galestrider": "Galestrider",
  "enemy.arcbeak": "Arcbeak",
  "enemy.stormback": "Stormback",
  "enemy.cloudstalker": "Cloudstalker",
  "enemy.tempestWarden": "Tempest Warden",
  "rift.toTempest": "Enter Tempest Reach",
  "rift.open": "🌀 Travel through the Rift Gate",
  "map.tempest": "Tempest Reach",
  "weapon.galeBlade": "Gale Blade",
  "weapon.tempestCleaver": "Tempest Cleaver",
  "weapon.arcLongbow": "Arc Longbow",
  "chest.skyruin": "Skyruin Chest",
  "chest.tempest": "Tempest Chest (up to mythic)",

  // World / Regions travel screen
  // 10.5O — missions (with rewards)
  "mission.title": "MISSIONS",
  "mission.done": "MISSION COMPLETE",
  "mission.ready": "Mission complete",
  "mission.claim": "Claim reward",
  "mission.sub": "Complete and get paid instantly — a bigger one takes its place.",
  "mission.total": "Missions completed: {n}",
  "mission.doneTimes": "· completed {n}×",
  "mission.reward": "Reward",
  "mission.m_kill": "Slay monsters",
  "mission.m_elite": "Defeat Elites",
  "mission.m_chest": "Open chests",
  "mission.m_explore": "Explore territories",
  "mission.m_hunt": "Great hunt",
  "mission.m_boss": "Defeat a Boss",

  // 10.5M — territories (30 map pieces, each with its own gang)
  "terr.gang": "gang: {name}",
  "terr.tier": "Tier {n}",
  "terr.here": "You are here",
  "terr.cleared": "{name} cleared — the gate opened",
  "daily.title": "Daily",
  "daily.ready": "Daily mission complete — claim it",
  "daily.done": "Daily claimed",
  "daily.claimed": "Claimed — come back tomorrow",
  "daily.streak": "{n} dailies completed",
  "mission.d_kill": "Slay monsters",
  "mission.d_elite": "Defeat champions",
  "mission.d_chest": "Open chests",
  "mission.d_territory": "Explore territories",
  "mission.d_hunt": "Great hunt of the day",
  "mission.d_boss": "Defeat a boss",
  "mission.d_elite2": "Champion hunt",
  "terr.task.hunt": "slay {n} here",
  "terr.lockedHere": "{name} locked · {what} in {here}",
  "terr.lockedChain": "{name} locked · conquer a neighboring territory first",
  "terr.mission": "Mission",
  "terr.conquered": "Conquered — gates open",
  "terr.needLevelShort": "needs Lv {n}",
  "terr.neighborFirst": "conquer a neighbor first",
  "terr.mtask.hunt": "slay {p}/{t}",
  "terr.mtask.champion": "defeat the champion",
  "terr.mtask.chest": "open the chest",
  "world.goals": "Area missions",
  "world.goalsOpen": "opens the Rift Gate → {name} (Lv {n}+)",
  "world.goalsDepth": "closes the loop → Depth {n}",
  "map.nextStep": "Next step:",
  "map.anywhere": "any monster in the area counts",
  "map.explore": "explore",
  "map.tapGoal": "Tap a mission above to see on the map where to do it, or a territory for its details.",
  "map.focus.territories": "🧭 Visit {n} more new territory(ies) to finish — the lit ones haven't counted yet this run. Just step into each; going back into one that already counted doesn't add again.",
  "map.focus.champions": "👑 Champions still alive in {n} territory(ies) — the big pink dots.",
  "map.focus.chests": "📦 Closed chests in {n} territory(ies) — the golden chests on the map (the number = how many together). On ??? the badge only tells there's a chest: explore to find where.",
  "map.boss.lockAlpha": "defeat {have}/{need} elites to open the Apex Fang's Den",
  "map.boss.lockColossus": "defeat {have}/{need} Shard Wardens and explore the Wilds to open the Colossus gate",
  "map.tab.lockGoals": "{area} missions {done}/{total}",
  "map.bosses": "Bosses",
  "map.focus.kills": "⚔ Any monster in the area counts. Open territories are lit.",
  "map.focus.boss": "💀 {name} is here (lit on the map).",
  "map.focus.bossSleep": "💤 The area Guardian is still asleep — it wakes at {have}/{need} kills in this area.",
  "map.focus.bossUnknown": "💀 This area's boss hasn't shown up on the map yet.",
  "map.focus.none": "Nothing of that in sight — explore the nearby ??? (dashed outline).",
  "map.focus.nearest": "Closest: {name} (~{m} m)",
  "map.focus.clear": "clear",
  "world.goalsDone": "area complete — Rift Gate open",
  "terr.task.champion": "defeat the champion",
  "terr.task.chest": "open the chest",
  "terr.locked": "{name} locked · {what}",
  "terr.lockedLevel": "{name} locked · needs level {n}",
  "terr.champion": "Champion",
  "terr.title": "REGION MAP",
  "terr.spires": "Spires",
  "terr.quarry": "Quarry",
  "terr.hollow": "Hollow",
  "terr.lowreach": "Lowreach",
  "terr.saltflat": "Salt Flat",
  "terr.geode": "Geode",
  "terr.deepvein": "Deep Vein",
  "terr.skyshelf": "Sky Shelf",
  "terr.updraft": "Updraft",
  "terr.boneyard": "Stone Boneyard",
  "terr.gale": "Gale",
  "terr.arcfield": "Arc Field",
  "terr.spiredge": "Spire Edge",
  "terr.stillwind": "Stillwind",
  "terr.pillars": "Pillars",
  "terr.thunderpit": "Thunder Pit",
  "terr.highroost": "High Roost",
  "terr.shroud": "Shroud",
  "terr.stormeye": "Storm Eye",
  "terr.lastledge": "Last Ledge",
  "terr.apex": "Apex",
  "terr.legend": "Drag the map · tap a territory to see its gang",
  "terr.unknown": "Unexplored territory — go there to reveal it",
  "terr.unknownNear": "Unexplored territory, next to {name}.",
  "terr.unknownLevel": "Needs Lv {n} to conquer.",
  "terr.unknownGo": "You can go now — walk there to reveal it.",
  "terr.ravine": "Forgotten Ravine",
  "terr.crest": "Void Crest",
  "terr.shardfield": "Shard Field",
  "terr.grove": "Corrupted Grove",
  "terr.den": "Alpha Den",
  "terr.fangtrail": "Fang Trail",
  "terr.whisper": "Whispering Woods",
  "terr.clearing": "Void Clearing",
  "terr.garden": "Crystal Garden",
  "terr.marsh": "Pale Marsh",
  "terr.entrance": "Forest Entrance",
  "terr.hills": "Low Hills",
  "terr.roots": "Ancient Roots",
  "terr.sleepgate": "Sleeping Gate",
  "terr.southmist": "Southern Mist",
  "terr.vein": "Fractured Vein",
  "terr.wardens": "Warden Grounds",
  "terr.mesa": "Shattered Mesa",
  "terr.cliffs": "Aether Cliffs",
  "terr.flats": "Crystal Flats",
  "terr.glint": "Glinting Slope",
  "terr.shardpit": "Shard Pit",
  "terr.brokenpass": "Broken Pass",
  "terr.fissures": "Fissure Field",
  "terr.thunder": "Thunder Peak",
  "terr.crown": "Tempest Crown",
  "terr.gorge": "Arc Gorge",
  "terr.overlook": "Cloud Overlook",
  "terr.windward": "Windward Path",
  "terr.terrace": "Ruin Terrace",

  // 10.5U — contextual tutorial
  "tip.move": "Use the stick to move — attacking is automatic. Watch your health bar.",
  "tip.leaveBase": "You left the base ring: monsters attack out here. Step back inside to heal.",
  "tip.chain": "Weapons in your bag get chained to you and attack on their own — up to 3 at once (4 with VIP), besides the one in your hand.",
  "tip.levelup": "You earned a Void Point: spend it on the Tree (✦) to upgrade damage, defense and more.",
  "tip.elite": "Elites lead a territory's gang: more Fragments and better loot.",
  "tip.mission": "Missions grant Fragments and XP. The current one shows at the top.",
  "tip.altar": "The Void Altar trades essence for permanent attributes.",
  "tip.map": "Drag the map to explore. Each territory has a different gang.",
  "tip.shop": "You have Fragments now: the Shop (🛒) sells health, power, Tree points and hunts.",
  "tip.territory": "New territory! Each piece of the map has its own monsters and champion.",
  "tip.death": "Dying sends you back to base at 30% health and costs ONE bag item — never an equipped one, never coins or XP.",

  // 10.5W — progress backup
  "settings.stickSide": "Joystick",
  "settings.stickRight": "on the right",
  "settings.stickLeft": "on the left",
  // 10.6C — camera distance
  "settings.camera": "Camera",
  "settings.cam0": "Close",
  "settings.cam1": "Default",
  "settings.cam2": "Far",
  "settings.cam3": "Wide",
  "backup.title": "Progress backup",
  "backup.hint": "Generate a code, save it somewhere and paste it on another device to continue.",
  "backup.placeholder": "paste your backup code here",
  "backup.export": "Generate & copy",
  "backup.import": "Restore",
  "backup.copied": "Code generated and copied — keep it safe.",
  "backup.restored": "Progress restored! Reloading...",
  "backup.invalid": "Invalid code. Make sure you copied all of it.",

  "world.tooLow": "Too dangerous: come back at level {n}",
  "world.title": "REGIONS",
  "world.close": "Close",
  "world.travel": "Travel",
  "world.here": "You are here",
  "world.locked": "Locked",
  "world.complete": "Complete",
  "world.inProgress": "In progress",
  "world.tier": "Tier {n}",
  "world.recLevel": "Lv {n}+",
  "world.mastery": "Mastery {n}/{max}",
  "world.riftSurge": "Rift Surge",
  "world.masteryBtn": "Mastery",
  "world.surgeMax": "Surge {n} ready",
  "world.surgeActive": "Surge {n} ACTIVE",

  // Regional Mastery
  "mastery.title": "REGION MASTERY",
  "mastery.lv": "Lv {n}",
  "mastery.maxed": "MASTERED",
  "regionMastery.levelUp": "{region} Mastery {n}",
  "mastery.masteredBanner": "{region} — REGION MASTERED",
  "mastery.reward.essence": "Essence cache",
  "mastery.reward.chest": "Regional chest",
  "mastery.reward.loot": "+ Loot chance in region",
  "mastery.reward.surge2": "Rift Surge II unlocked",
  "mastery.reward.surge3": "Rift Surge III unlocked",
  "mastery.reward.title": "Title (coming soon)",
  "mastery.reward.mastered": "REGION MASTERED",

  // Rift Surge
  "surge.title": "RIFT SURGE",
  "surge.normal": "Normal Region",
  "surge.normalDesc": "Standard difficulty and rewards.",
  "surge.tierName": "Surge {n}",
  "surge.select": "Select",
  "surge.on": "Active",
  "surge.activate": "Activate",
  "surge.locked": "Locked",
  "surge.desc1": "Tougher foes · +mastery, loot & essence.",
  "surge.desc2": "Much tougher · more elites · greater rewards.",
  "surge.desc3": "Brutal · frequent elites · best rewards.",
  "surge.objective": "Objective: defeat {kills} enemies incl. {elites} elite(s)",
  "surge.hud": "Kills {k}/{nk} · Elites {e}/{ne}",
  "surge.doneShort": "OBJECTIVE COMPLETE",
  "surge.activated": "RIFT SURGE {n} ACTIVE",
  "surge.ended": "Rift Surge ended",
  "surge.complete": "RIFT SURGE COMPLETE",

  "attack.stoneSweep": "Stone Sweep",
  "attack.fractureCharge": "Fracture Charge",
  "attack.shardRain": "Shard Rain",
  "attack.corePulse": "Core Pulse",
  "attack.fractureLeap": "Fracture Leap",
  "attack.prismaticLine": "Prismatic Line",
  "attack.coreOverload": "Core Overload",

  "weapon.colossusEdge": "Colossus Edge",
  "weapon.aetherLongbow": "Aether Longbow",
  "loot.colossusChest": "Colossus Chest",
  "chest.colossus": "Colossus Chest (up to mythic)",

  // 10.6R — Correio + Diamantes + VIP
  "mail.title": "Mailbox",
  "mail.empty": "No messages",
  "mail.claim": "Claim",
  "mail.claimed": "Claimed",
  "mail.interact": "Mailbox",
  "mail.welcome.title": "Welcome, Hunter!",
  "mail.welcome.body": "Welcome to the Void! Here is a starting gift to help you on your journey.",
  "mail.daily.title": "Daily Login Bonus",
  "mail.daily.body": "Streak day {day}! Come back tomorrow to keep climbing (skip a day and it resets).",
  "mail.boss.voidAlpha.title": "Apex Fang Defeated!",
  "mail.boss.voidAlpha.body": "Congratulations on defeating the Apex Fang! A Fragment reward awaits you.",
  "mail.boss.aetherColossus.title": "Aether Colossus Defeated!",
  "mail.boss.aetherColossus.body": "The Colossus has fallen! Claim your Fragment reward.",
  "mail.depth.title": "Depth Milestone!",
  "mail.depth.body": "You reached Depth {depth}! Here is your reward.",
  "mail.newMail": "New mail!",
  "ads.revive": "📺 Revive here (50% HP, keep your items)",
  "ads.reviveVip": "👑 Revive here (VIP · no ad)",
  "ads.reviveNote": "{n} left today",
  "ads.revived": "✨ You revived on the spot!",
  "ads.dailyDouble": "📺 Claim DOUBLE",
  "ads.dailyDoubleVip": "👑 Claim DOUBLE",
  "ads.freeDiamonds": "📺 +{n} 💎 free ({left} today)",
  "ads.xpBoost": "📺 +50% XP for 15 min ({left} today)",
  "ads.sectionTitle": "Free by watching",
  "ads.vipHint": "VIP gets all of this without watching ads.",
  "ads.notRewarded": "Ad skipped — no reward.",
  "mail.season.title": "Season {season} Prize!",
  "mail.season.body": "You finished #{rank} in {category} in Season {season}. Congratulations, Hunter!",
  "currency.diamonds": "Diamonds",
  "vip.title": "VIP Areas",
  "vip.shopTitle": "VIP Shop",
  "vip.unlock": "Unlock ({cost} 💎)",
  "vip.unlocked": "Unlocked",
  "vip.acquired": "Acquired",
  "vip.locked": "Locked",
  "vip.notEnough": "Not enough Diamonds",
  "vip.noCoins": "Not enough Fragments",
  "vip.noTier": "No VIP",
  "vip.needsPrev": "Requires {tier} first",
  "vip.buyTier": "Acquire ({cost} 💎)",
  "vip.tierUp": "{tier} unlocked!",
  "vip.tier.bronze": "VIP Bronze",
  "vip.tier.silver": "VIP Silver",
  "vip.tier.gold": "VIP Gold",
  // 10.9EJ — bonus ativos no HUD
  "buff.spell": "Spell buff active",
  "buff.xp": "XP boost",
  "buff.coin": "Coin boost",
  "buff.luck": "Luck: rarer drops",
  "buff.contract": "Contract: +75% Fragments and essence",
  "buff.event": "Void Invasion: stacked damage and defense",
  "buff.bless": "Blessings: on death, revive on the spot with no ad — or, if you respawn at base, protect your Bag (uses 1)",
  "buff.vip": "VIP active",
  "map.gateOpen": "Open gate", // 10.9EL
  "map.gateLocked": "Locked", // 10.9EL
  // 10.9EO — RAID (boss mundial)
  "boss.raidTitan": "Eclipse Titan",
  "raid.title": "Raid",
  "raid.soon": "⚔️ Titan Raid in {t}",
  "raid.openLobby": "⚔️ RAID OPEN · Titan wakes in {t} · Join",
  "raid.openLive": "⚔️ RAID LIVE · Join",
  "raid.entering": "⚔️ Entering the Eclipse Titan Raid...",
  "raid.noCloud": "Raid unavailable: no cloud account connection.",
  "raid.lost": "Raid: {why}. Returning to your game.",
  "raid.unverified": "Your profile isn't in the cloud yet: your damage has a safety cap.",
  "raid.win": "🏆 TITAN DEFEATED! You placed {rank} of {n}",
  "raid.fail": "⌛ Time's up — the Titan held on.",
  "raid.backLater": "🌑 The Titan respawns in {t} — come back via the LIVE RAID button",
  "raid.leaveBtn": "Leave",
  "hud.stackShow": "Show missions and bonuses",
  "hud.stackHide": "Collapse",
  "raid.down": "You fell! Back in {s}s...",
  "raid.online": "in raid",
  "raid.wakes": "wakes in {t}",
  "raid.topDmg": "Top damage",
  "raid.topTaken": "Most damage taken",
  "raid.unique": "🌟 UNIQUE Titan item!",
  "raid.respawnIn": "🌑 The Titan respawns in {t}",
  "raid.myDmg": "Your damage",
  "raid.victory": "TITAN DEFEATED",
  "raid.timeUp": "TIME'S UP",
  "raid.yourRank": "You: {rank} of {n}",
  "raid.suspect": "Part of your damage was rejected by the server (above what your character can do).",
  "raid.reward": "🎁 Raid: +{xp} XP · +{coins} 🪙 · +{dia} 💎",
  // 10.9EQ — ROUBO DE VIDA
  "equipment.attr.maxHpPct": "HP %",
  "equipment.attr.damagePct": "Damage %",
  "equipment.attr.lifesteal": "Life Steal",
  "attr.lifesteal": "LEECH",
  "treeeffect.lifeStealPct": "Life Steal",
  "stat.lifeSteal": "Life Steal",
  "node.sur_leech": "Bloodthirst",
  "node.sur_leech.d": "Each hit returns +1% of damage dealt as health, per rank (attacks, arrows, Chain and spells).",
  "node.sur_vampire": "Vampiric Pact",
  "node.sur_vampire.d": "+1.5% of damage dealt returns as health, per rank. Stacks with Bloodthirst and gear.",
  // 10.9ER — AJUDA DOS ATRIBUTOS (tocar no atributo)
  "attrhelp.hint": "Tap an attribute to see what it does",
  "attrhelp.dpsTotal": "TOTAL damage per second: how much health you take from monsters each second, adding your hits and your Chain weapons.",
  "attrhelp.moveSpeed": "How fast the Hunter walks. Faster = dodge hits and reach monsters sooner.",
  "attrhelp.maxHp": "How much health you have. If it hits zero, you fall and return to base.",
  "attrhelp.regen": "Health that comes back by itself every second. If you took damage in the last 4 seconds, it heals half.",
  "attrhelp.lifeSteal": "Part of the damage YOU deal returns as health (hits, arrows, Chain and spells). Heals at most 4% of health per second.",
  "attrhelp.armor": "Reduces damage you take from any hit. The value beside it shows the real reduction.",
  "attrhelp.damage": "Damage of each of your hits, before critical and bonuses.",
  "attrhelp.dps": "Damage per second of your hits (without the Chain), counting attack speed and critical.",
  "attrhelp.attackSpeed": "How many hits you deal per second.",
  "attrhelp.attackRange": "How far your hit reaches. Bows and staffs reach farther than swords.",
  "attrhelp.critChance": "Chance for each hit to be CRITICAL, which hits harder.",
  "attrhelp.critDamage": "How hard a critical hits. 150% = the critical deals one and a half times normal damage.",
  "attrhelp.dmgSlash": "Extra damage with SLASHING hits (swords and axes).",
  "attrhelp.dmgPierce": "Extra damage with PIERCING hits (bows).",
  "attrhelp.dmgBlunt": "Extra damage with BLUNT hits (clubs).",
  "attrhelp.vsElite": "Extra damage against Elites, Champions and Bosses.",
  "attrhelp.execute": "Extra damage against monsters below 30% health — ends fights faster.",
  "attrhelp.resilience": "Reduces ALL damage you take, of any type, after armor.",
  "attrhelp.defSlash": "Reduces SLASHING damage you take.",
  "attrhelp.defPierce": "Reduces PIERCING damage you take (arrows and spikes).",
  "attrhelp.defBlunt": "Reduces BLUNT damage you take (smashes).",
  "attrhelp.block": "Chance to BLOCK a hit: you take only half the damage and get pushed less.",
  "attrhelp.hookRange": "How far the Hook reaches to pull a monster.",
  "attrhelp.hookCooldown": "Wait time to use the Hook again.",
  "attrhelp.sprintDuration": "How long the Sprint lasts (» button).",
  "attrhelp.sprintCooldown": "Wait time to sprint again.",
  "attrhelp.chainCount": "How many Bag weapons are bound to the Chain, orbiting you and attacking on their own.",
  "attrhelp.chainDps": "Combined damage per second of your Chain weapons.",
  "attrhelp.chainReach": "How far the Chain weapons reach monsters.",
  // 10.9ES — NOVIDADES da atualizacao
  "update.title": "What's new",
  "update.reward": "Gift for this update: ",
  "update.claim": "Claim and play",
  "update.ok": "Play",
  "update.got": "🎁 +{coins} 🪙 · +{dia} 💎",
  "training.confirm": "Confirm: {what}?", // 10.9ET
  // 10.9EV
  "attr.bought": "bought",
  "attr.boughtN": "bought {n}×",
  "shop.confirmBuy": "Buy {name} for {price}?", // 10.9EJ
  "vip.confirmTitle": "Confirm purchase",
  "vip.confirmPack": "Buy {diamonds} 💎 for {price}?",
  "vip.confirmPackFirst": "Buy {diamonds} 💎 (first purchase DOUBLED) for {price}?",
  "vip.confirmPackFirstPct": "Buy {diamonds} 💎 (first purchase +{pct}%) for {price}?",
  "vip.confirmPass": "Activate the VIP Pass for {days} days ({price}) and get +{diamonds} 💎?",
  "vip.confirmTestNote": "Test mode: no real charge is made.",
  "vip.confirmYes": "Confirm",
  "vip.confirmNo": "Cancel",
  "vip.tier.platinum": "VIP Platinum",
  "vip.tier.diamond": "VIP Diamond",
  "vip.tier.master": "VIP Master",
  "vip.points": "{n} VIP points",
  "vip.pointsNext": "{n} → {tier}",
  "vip.pointsMax": "Max tier!",
  "vip.pointsReq": "{n} VIP points",
  "vip.pointsMissing": "{n} VIP points to go",
  "vip.pointsHint": "Every 💎 spent in-game is 1 VIP point — same for 💎 earned by playing and 💎 purchased. Tiers unlock automatically.",
  "vip.perk.xp": "+{pct}% XP on everything",
  "vip.perk.coins": "+{pct}% Fragments",
  "vip.perk.essence": "+{pct}% Essence collected",
  "vip.perk.absorb": "+{pct}% Absorption (HP/damage)",
  "vip.perk.bagBonus": "+{n} bag slots (tier bonus)",
  "vip.perk.weaponSlot": "+1 weapon slot in your chain (one more weapon attacking)",
  "vip.perk.dropBoost": "Improved drop rarity",
  "vip.perk.dailyDiamonds": "+{n} 💎 daily mail bonus",
  "vip.perk.areas": "{n} VIP areas: bonus XP in the region (Forest ×1.5 · Wilds ×1.8 · Tempest ×2.0)",
  "vip.packsTitle": "Diamond Packs",
  "vip.packsHint": "💎 is premium currency. The packs are not on sale yet. In the meantime, 💎 comes from playing: daily login, daily mission, Depth and ads.",
  "vip.firstPackHint": "🎁 Your first purchase comes with an extra bonus — this time only.",
  "vip.packSoon": "Purchase coming soon — payment integration pending",
  "vip.testPurchase": "[TEST] +{amount} 💎 credited (no charge)",
  "vip.testPurchaseFirst": "🎉 [TEST] 1st purchase DOUBLED: +{amount} 💎 credited (no charge)",
  "vip.testPurchaseFirstPct": "🎉 [TEST] 1st purchase +{pct}%: +{amount} 💎 credited (no charge)",
  "vip.pack.starter": "Starter Pack",
  "vip.pack.mini": "Mini Pack",
  "vip.pack.small": "Small Pack",
  "vip.pack.medium": "Medium Pack",
  "vip.pack.large": "Large Pack",
  "vip.pack.mega": "Mega Pack",
  "vip.pack.ultimate": "Ultimate Pack",
  "vip.pack.legend": "Legendary Pack",
  "vip.pack.tag.popular": "POPULAR",
  "vip.pack.tag.best": "BEST VALUE",
  "vip.pack.bonusLabel": "BONUS",
  "vip.pack.firstDouble": "1st purchase ×2",
  "vip.pack.firstPct": "1st purchase +{pct}%",
  "vip.crystallineHollow": "Crystalline Hollow",
  "vip.crystallineHollow.desc": "Rare crystals and tougher monsters in the Forgotten Forest. Better loot and XP.",
  "vip.aetherSanctum": "Aether Sanctum",
  "vip.aetherSanctum.desc": "Secret zone in the Shattered Wilds. Elite enemies and exclusive drops.",
  "vip.stormNexus": "Storm Nexus",
  "vip.stormNexus.desc": "The heart of the storm. Maximum challenge with the best rewards in the game.",
  "vip.areaUnlocked": "VIP area unlocked!",
  "vip.region": "Region: {region}",
  "vip.bonus": "XP ×{mult} · Better loot",
  "mail.claimAll": "Claim all",
  "mail.allClaimed": "All claimed!",
  "mail.levelUp.title": "Level Up!",
  "mail.levelUp.body": "Congratulations on reaching level {level}! Here is a gift.",
  "mail.vipDaily.title": "VIP Daily Bonus",
  "mail.vipDaily.body": "Exclusive reward from your VIP plan. Thank you for being VIP!",
  "dshop.title": "Spend Diamonds",
  "dshop.vipDiscount": "VIP: -{pct}% off everything",
  "dshop.alreadyOwned": "You already own this outfit",
  "dshop.outfitUnlocked": "Outfit unlocked! Check the Wardrobe",
  "dshop.noWeapon": "Equip a weapon first",
  "dshop.chestRare": "Crystal Chest",
  "dshop.chestEpic": "Aether Chest",
  "dshop.chestLegend": "Legendary Chest",
  "dshop.chestMythic": "Mythic Chest 🏆",
  "dshop.bossWeapon": "Legendary Boss Weapon",
  "dshop.bossWeaponGot": "Legendary Boss Weapon acquired!",
  "dshop.noBossWeapon": "No boss weapon available",
  "dshop.coinPack": "+2000 Fragments",
  "dshop.shardPack": "+20 Weapon Shards",
  "dshop.bagSlots": "🎒 Bag +10 slots",
  "dshop.bagMax": "Bag is already at max ({max} slots)",
  "dshop.bagFull": "MAX",
  "dshop.bagBought": "Bag: {n}/{max} slots",
  "dshop.boostXp": "2× XP · 30 min",
  "dshop.boostCoin": "2× Coins · 30 min",
  "dshop.boostLuck": "Luck · better drops · 30 min",
  "dshop.boostCombo": "2× XP + Coins · 60 min",
  "dshop.elixir3": "🧪 Protection Elixir ×3",
  "dshop.elixir10": "⚗️ Protection Elixir ×10",
  "dshop.elixirGot": "+{n} Protection Elixir",
  "dshop.bless1": "🕊️ Blessing ×1",
  "dshop.bless5": "🕊️ Blessing ×5",
  "dshop.blessGot": "+{n} Blessing",
  "bless.saved": "🕊️ The Blessing protected you — no item lost! ({n} left)",
  "bless.lost": "☠️ No Blessing: you lost {item} from your bag!",
  "bless.revive": "🕊️ Revive here with a Blessing (no ad · {n})",
  "bless.revived": "🕊️ The Blessing revived you here! ({n} left)",
  "dshop.outfitGold": "Golden VIP Outfit",
  "dshop.outfitObsidian": "Obsidian Outfit",
  "dshop.outfitRoyal": "Royalty Outfit",
  "vip.passTitle": "VIP Pass (30 days)",
  "vip.passName": "VIP Pass Active",
  "vip.passNameOff": "VIP Pass",
  "vip.passDuration": "{days} days · Exclusive multiplicative bonuses",
  "vip.passRemaining": "Active · {days} days remaining",
  "vip.passBuy": "Activate Pass · {cost}",
  "vip.passRenew": "Renew +30 days · {cost}",
  "vip.passActivated": "VIP Pass activated for {days} days!",
  "vip.passActivatedBonus": "VIP Pass activated for {days} days! +{diamonds} 💎 bonus credited.",
  "vip.passOutfitGot": "Exclusive {name} outfit unlocked in the Wardrobe!",
  "vip.pass.bonusDiamonds": "Diamond bonus on activation",
  "vip.pass.xp": "XP on top of EVERYTHING (multiplies other bonuses)",
  "vip.pass.coin": "Fragments on top of everything",
  "vip.pass.daily": "Bonus diamonds per day in the mail",
  "vip.pass.weaponSlot": "VIP weapon slot: +1 weapon attacking in your chain",
  "vip.pass.outfit": "Exclusive {name} outfit — yours forever",
  "attr.shopTitle": "Buy Attributes (Permanent)",
  "attr.shopHint": "Permanently boost your character — every purchase is felt immediately. And it stays that way: Rising Threat doesn't scale against what you buy here, so this edge is never caught up to as you progress.",
  "attr.hp.small": "Small HP",
  "attr.hp.med": "Medium HP",
  "attr.hp.big": "Max HP",
  "attr.hp.mega": "Supreme HP",
  "attr.dmg.small": "Small Damage",
  "attr.dmg.med": "Medium Damage",
  "attr.dmg.big": "Max Damage",
  "attr.dmg.mega": "Supreme Damage",
  "attr.regen.small": "Small Regen",
  "attr.regen.med": "Medium Regen",
  "attr.regen.big": "Max Regen",
  "attr.regen.mega": "Supreme Regen",
  "mail.markAllRead": "Mark all read",
  "mail.deleteRead": "Delete read",
  "inventory.needLevel": "Requires level {n} to equip",
  "inventory.autoEquipped": "Equipped: {name}",
  "forge.title": "Forge",
  "forge.hint": "Raise ANY equipment's LEVEL (1→250) with SHARDS ✨ and FRAGMENTS 🪙 (cost grows with level and rarity). Above the safe level there's a BREAK CHANCE (drops 1 level) — the 🧪 Protection Elixir prevents the drop.",
  "forge.noCoins": "Not enough Fragments (need {n} 🪙)",
  "forge.empty": "No equipment in the bag. Kill monsters and open chests to get items.",
  "forge.upgradeTo": "Forge → L{n}",
  "forge.max": "Max",
  "forge.safe": "safe",
  "forge.risk": "⚠ {p}% break",
  "forge.protected": "🧪 {p}% (protected)",
  "forge.protect": "Protect with elixir",
  "forge.elixirsHave": "Elixirs: {n}",
  "forge.noElixir": "No elixir (💎 shop sells protection)",
  "forge.up": "Forged! Level {n}",
  "forge.saved": "🧪 Elixir saved it! Level {n}",
  "forge.broke": "💥 Broke — dropped to level {n}",
  "forge.noShards": "Not enough shards",
  "wardrobe.short": "Outfit",
  "class.title": "Choose your Class",
  "class.charsTitle": "Your Characters",
  "class.sub": "Each class is a character with its own progress (level, tree, items).",
  "class.choose": "Choose",
  "class.play": "Play",
  "class.create": "Create character",
  "class.nameTitle": "Name your {cls}",
  "class.nameSub": "Pick a name (or tap a suggestion). It can't match another character.",
  "class.namePlaceholder": "Character name",
  "class.nameConfirm": "Create",
  "class.nameTooShort": "Name too short (min. 2 letters).",
  "class.nameTaken": "You already have a character with that name.",
  "inventory.unequippedLevel": "{n} item(s) above your level went back to the bag.",
  "voidTree.rebalanced": "✦ Void Tree rebalanced: it's now 1 point every 2 levels. Your points were refunded — redistribute!",
  "class.wrongWeapon": "That weapon isn't for your class",
  "class.delete": "Delete",
  "class.deleteConfirm": "Delete the {name}? All of this character's progress is gone forever.",
  "class.warrior.name": "Warrior",
  "class.warrior.desc": "Melee tank: high HP and armor, solid damage.",
  "class.archer.name": "Archer",
  "class.archer.desc": "Agile ranged: fast attacks and crits, less HP.",
  "class.mage.name": "Mage",
  "class.mage.desc": "Glass cannon: huge magic damage, but fragile.",
  "class.necromancer.name": "Necromancer",
  "class.necromancer.desc": "Summons servants that hunt and hit monsters. Punishes from afar with the staff.",
  "sell.title": "Sell",
  "sell.hint": "Tap items to mark them and sell several at once for 🪙. Auto-sell turns drops up to the chosen rarity into coins instantly (equipped items are never sold).",
  "sell.auto": "Auto-sell up to:",
  "sell.off": "Off",
  "sell.markLow": "Mark common/uncommon",
  "sell.clear": "Clear",
  "sell.empty": "Bag empty. Kill monsters and open chests to get items.",
  "sell.sellN": "Sell {n} · +{coins} 🪙",
  "sell.sold": "Sold {n} · +{coins} 🪙",
  "sell.autoSold": "Auto-sold +{coins} 🪙",
  "boss.challenge": "Challenge Boss",
  "test.interact": "🔥 Test Arena (1 of every monster)",
  "test.spawned": "Test Arena: {n} monsters summoned!",

  // 10.9BY — Skills + Training
  "skills.title": "🎯 Skills",
  "skills.sword": "Sword",
  "skills.axe": "Axe",
  "skills.mace": "Mace",
  "skills.ranged": "Ranged",
  "skills.magic": "Magic",
  "skills.summon": "Summoning",
  "skills.defense": "Defense",
  "skills.inUse": "in use",
  "skills.max": "MAX",
  "skills.bonusWeapon": "+{dmg}% damage · +{spd}% spd",
  "skills.bonusDefense": "-{n}% damage taken",
  "skills.levelUp": "{icon} {name} level {n}!",
  "skills.hint": "Skills level up by fighting (hits, kills, bosses; Defense when taking damage) and at the Training Dummy in the Sanctuary (offline, real time: 🪙/h or 💎).",
  "source.skills": "Skills",
  "training.interact": "🎯 Training Dummy",
  "training.train": "Train {name}",
  "training.training": "Training {name}",
  "training.left": "{time} left",
  "training.done": "done!",
  "training.rate": "{n} XP/min",
  "training.pending": "{n} XP earned",
  "training.willGain": "Yields {n} XP",
  "training.perHour": "{n} 🪙/h",
  "training.payCoins": "Train · {n} 🪙",
  "training.payDiamonds": "Pay with {n} 💎",
  "training.collect": "Collect +{n} XP",
  "training.double": "📺 Double",
  "training.doubleVip": "👑 Double",
  "training.finishNow": "Finish now · {n} 💎",
  "training.started": "🎯 {name} training started ({h}h)",
  "training.collected": "🎯 +{n} XP in {name}",
  "training.finished": "Training complete — collect at the Training Dummy",
  "training.busy": "A training session is already running",
  "training.hud": "{time}",
  "training.hudDone": "ready!",

  // 10.9IH - GUIDED TUTORIAL (tour) + "How to play" manual
  "guide.skip": "Skip",
  "guide.start": "Take the tutorial",
  "guide.next": "Next",
  "guide.finish": "Done",
  "guide.done": "✅ Tutorial complete. The full manual lives in Pause → How to play.",
  "guide.welcome.t": "Welcome to the Void",
  "guide.welcome.b": "A quick walk through the screen, under two minutes. You can skip now or partway through, and redo it later in Pause → How to play.",
  "guide.move.t": "Moving",
  "guide.move.b": "Drag the stick to move the Hunter. Walk a little to continue.",
  "guide.auto.t": "Attacking is automatic",
  "guide.auto.b": "You never tap to attack: the Hunter strikes the nearest enemy in weapon range on its own. Your job is choosing where to stand and when to back off.",
  "guide.life.t": "Your health",
  "guide.life.b": "The bar floats above the Hunter so you never have to look away. It turns red below a third.",
  "guide.base.t": "The base is safe",
  "guide.base.b": "Inside the base ring no monster can enter and you recover 8% of your health per second. Outside, healing drops to 0.7% per second, and only starts 8 seconds after the last hit.",
  "guide.sprint.t": "Sprint",
  "guide.sprint.b": "60% more speed for 2 seconds, on a 4 second cooldown. It is for escaping a crowd, not a dodge: you still take damage.",
  "guide.hook.t": "Hook",
  "guide.hook.b": "Pulls an enemy to you. It is the only way a melee fighter reaches a flyer, because melee weapons cannot hit flying enemies.",
  "guide.potion.t": "Potion",
  "guide.potion.b": "Heals half your health instantly, on an 8 second cooldown. Buy them in the Shop, or find them in chests.",
  "guide.gear.t": "Weapon and chains",
  "guide.gear.b": "The first slot is the weapon in your hand. The others are the chains: bag weapons that float and attack on their own. They open at levels 10, 20 and 30.",
  "guide.status.t": "Level, XP and currency",
  "guide.status.b": "Every 2 levels you earn 1 Void Tree point. Below that sit Essence, Fragments and Diamonds.",
  "guide.mission.t": "Current mission",
  "guide.mission.b": "Three missions run at once, plus a daily one. The reward does not drop by itself: tap Claim when it is done.",
  "guide.map.t": "Minimap",
  "guide.map.b": "Shows where you are and what you have explored. Tap it to open the World Map, with every territory and what each one still needs.",
  "guide.menu.t": "The shortcuts",
  "guide.menu.b": "Bag, Shop, Missions, Mail and VIP. The forge, selling and the wardrobe live inside the Bag.",
  "guide.mail.t": "Don't forget the Mail",
  "guide.mail.b": "There's a reward waiting here every day — and it grows the longer you keep coming back. Skip a day and the streak resets.",
  "guide.more.t": "Settings and manual",
  "guide.more.b": "The gear opens graphics quality, language and controls. The full manual, with forge, Threat, bosses and the Tree, is in Pause → How to play.",
  "htp.title": "How to play",
  "htp.sub": "Every part of the game, explained. Tap a section to open it.",
  "htp.replay": "Redo the guided tutorial",
  "htp.combat.t": "Combat",
  "htp.combat.b": "Attacking is automatic: the Hunter strikes the nearest enemy in weapon range by itself. It picks a target within 9 metres and only drops it past 11.5.\nThere is no dodge. Sprint gives 60% speed for 2 seconds and is for repositioning, not for going untouchable.\nMelee weapons cannot hit flying enemies. Use a bow or staff, or bring them down with the Hook.\nElites, champions and bosses take a slice of your MAXIMUM health that ignores armour: 5%, 9% and 10% per hit. And all damage reduction stops at 80%, so you always take at least a fifth of the blow.",
  "htp.base.t": "The safe base",
  "htp.base.b": "Inside the 14 metre ring you are invulnerable, monsters disengage, and you recover 8% of your health per second.\nIn the field regeneration is 0.7% per second, and only starts 8 seconds after the last hit.\nA banner marks both crossings: SAFE ZONE on the way in and COMBAT ZONE once you are fully out.\nThe base holds the Void Altar to the north, the mailbox, the PvP portal, the training dummy and, in the south-east corner, the Titan Rift portal.",
  "htp.chain.t": "Chained weapons",
  "htp.chain.b": "Up to 3 weapons from your bag (4 with VIP or the VIP Pass) float around you and attack on their own, with 5.5 metres of reach. They do hit flying enemies.\nEach chain hits for around 30% of what that weapon would hit for in your hand. The game picks the highest-damage ones your class can use and your level can equip.\nThe slots open by level: the second at 10, the third at 20 and the fourth at 30; the fifth is the VIP slot. The same weapon can show up in different rarities. Below level 10 you have no chains at all.",
  "htp.death.t": "Dying",
  "htp.death.b": "You return to base in 2 seconds with 30% health and 2 seconds of protection.\nThe penalty is ONE random item from your bag. Never an equipped item, never coins, never XP, never levels. Empty bag, nothing lost.\nA Blessing is spent instead of the item. And reviving on the spot, by video or VIP, cancels the penalty entirely.\nRunning away is costly: out of combat a monster regenerates 10% per second and goes back to full.",
  "htp.threat.t": "Threat: the world grows with you",
  "htp.threat.b": "Every monster you kill improves you permanently: part of its health becomes your maximum health, and part of its damage becomes your damage. That is Absorption.\nBut monsters scale with you, always a step behind. The more effective health you have, the harder they hit. The more damage you deal, the more health they get.\nNot everything counts equally: only half of what you absorbed from kills and 40% of what comes from gear feeds Threat. The other 60% of your forging is real net gain.\nThere is a ceiling: a monster never needs more of your hits than its tier limit, from 9 to 26, and a boss stops at 60.\nIn practice, growing is always worth it — but stacking only health and armour pays less than it looks, because the game reads that as effective health and answers with damage.",
  "htp.loot.t": "Items, rarity and tiers",
  "htp.loot.b": "Rarities: common, uncommon, rare, epic, legendary and mythic. Each step multiplies the stats and adds one more affix, up to 6 on mythic, and even common now comes with 1.\nEvery item asks for a level to equip: rare at 10, epic at 20, legendary at 35, mythic at 50. The TIER asks for more still: tier 2 at level 20, tier 7 at 150, tier 10 at 300, tier 14 at level 1000.\nDrops are capped to what you can already use, so hunting mythics at level 5 is pointless. The first area never drops legendary.\nA repeated weapon (same weapon and rarity as one you already have) goes inside it: +1 on its evolution bar and it still gives forge material. At 100 copies it goes up a rarity and keeps its forge level. Repeated armour turns into forge material. A full bag never loses a drop. The bag starts with 30 slots and goes up to 100 with diamonds.",
  "htp.forge.t": "Forge, breaking and selling",
  "htp.forge.b": "The forge takes any item from level 1 to 250. Each level gives 9% base damage on a weapon and 6% armour on a piece of gear.\nUp to level 15 there is no risk at all. Above that the break chance rises 0.4% per level, capped at 40%. Breaking spends the material and drops the item one level — it never destroys it.\nThe Protection Elixir turns a break into a save. It is consumed on every attempt that carried risk, not only when it saves you.\nSelling only works on bag items; equipped ones are skipped. The price rises 12% per forge level.",
  "htp.money.t": "The currencies",
  "htp.money.b": "Fragments come from kills, chests, missions and sales. They buy potions, healing, material, the Hunt Contract, health and power in the Shop. Prices rise with each purchase.\nEssence drops from monsters as orbs and is only useful at the Void Altar, for permanent attributes. The cost rises 35% per level.\nForge material is PER ITEM: material for one sword does not work on another.\nDiamonds are premium but earnable: 5 per daily login, 3 per daily mission, and 10 every 5 Depths. Bosses and levelling up do not give diamonds.",
  "htp.tree.t": "Void Tree",
  "htp.tree.b": "You earn 1 point every 2 levels, plus 1 for the first Apex Fang and 4 per Depth.\nThere are four branches: Power, Survival, Agility and your class branch. Filling everything costs around 870 points, and each branch ends in infinite nodes of 50 ranks.\nYou can respec for 10 diamonds; each respec makes the next one 1% more expensive.\nThe Tree opens from the Void Altar, in the base.",
  "htp.classes.t": "Classes, spells and skills",
  "htp.classes.b": "There are four: Warrior, with high health, armour and block; Archer, fast and critical; Mage, the highest damage and the lowest health; and Necromancer.\nThe class decides the weapon: warrior uses sword, axe and mace; archer uses the bow; mage and necromancer use the staff.\nEvery class has 3 base spells plus 3 more that unlock at levels 10, 25 and 40. The Grimoire, in the pause menu, picks which 3 of the 6 sit on your buttons.\nTwo tracks run alongside your level: Mastery for each weapon type, which rises by fighting, and the 7 Skills, trained at the base dummy even while the game is closed.",
  "htp.world.t": "Territories and Depth",
  "htp.world.b": "The map is split into territories. Opening one needs three things at once: a neighbour already conquered, the minimum level for its tier, and its local mission done.\nThe local mission is hunting 20 to 76 monsters of that gang, plus the champion and the chest when the territory has them.\nTo change region through the Rift Portal, every area goal must be closed AND you need the destination's recommended level.\nSome territories in the Shattered Wilds and the Tempest hurt on their own (ember, frost, gale and storm): you get a 2.5 s warning and then lose 5.5% of your health per second, until you put the right ring in the accessory slot. The rings are in the Shop and equip from level 16. Careful, they are crossed: the Ember Ring protects against frost, and the Frost Ring against ember. Tapping the warning at the top of the screen equips the ring (if it's in your Bag) or opens the Shop right on it.\nFinishing the last area raises your Depth: monsters gain health and damage, goals grow 50%, rewards rise 60% — and the whole map LOCKS again, to be reconquered.",
  "htp.missions.t": "Missions",
  "htp.missions.b": "Three missions are active at all times, with no timer and no energy. When one finishes the reward waits for you: tap Claim.\nThe daily is one per day, drawn from the calendar day, and pays diamonds on top of coins and XP. A missed day does not stack.\nRepeating the same mission pays more: each repeat adds 30% to the reward.",
  "htp.bosses.t": "Bosses",
  "htp.bosses.b": "Apex Fang, first area: kill 3 elites to open the barrier, enter the arena and accept the challenge.\nAether Colossus, second area: needs 3 Shard Wardens killed and all 4 sub-areas discovered.\nRegion Guardian: kills anywhere in the region charge it. When it wakes it drops a guaranteed legendary weapon, and it grows stronger every time you bring it down.\nEvery boss enters RAGE below 30% health. And every boss is leashed to its arena: walk out and the fight resets with no penalty.",
  "htp.endgame.t": "Titan Rift and endgame",
  "htp.endgame.b": "The portal in the south-east corner of the base leads to the Rift: 15 rooms outside the map, each with its own titan. Entering the portal itself requires nothing.\nThe doors require levels: room 1 at 10, room 5 at 45, room 10 at 100. The last five are prestige rooms at levels 200, 400, 600, 800 and 1000, and they also demand 25%, 50%, 70%, 90% and 100% of the Void Tree filled.\nThe door seals when you accept the challenge. Each room only counts again after 15 real hours.\nThe titan's exclusive weapon is rare: a 1.5% chance per kill.",
  // 10.9IT — painel de administracao: correio da equipe e conta suspensa
  "mail.admin.title": "Gift from the team",
  "mail.admin.body": "The VOID HUNTER team sent you this. {note}",
  "admin.grantBanner": "📬 You received {n} delivery(ies) from the team — check the Mailbox",
  "admin.levelSet": "⭐ The team set your level: {n}",
  "admin.wiped": "🧹 The team reset this account. Starting over…",
  "admin.itemRemoved": "🗑️ The team removed an item from your bag",
  "admin.itemLevelSet": "🔨 The team adjusted an item's forge level: level {n}",
  "admin.areaCompleted": "🗺️ The team unlocked the area: {name}",
  "ban.title": "Account suspended",
  "ban.body": "This account was suspended by the VOID HUNTER team.",
  "ban.until": "Suspended until {date}.",
  "ban.perm": "Suspension with no end date.",
};
